module.exports = __webpack_public_path__ + "img/insurance-cover.2b4c800f.jpeg";